/** /channel-partner/apply — the Channel Partner application form. */
import { createFileRoute } from '@tanstack/react-router';
import { ChannelPartnerApplyPage } from '@/features/channel-partner/components/apply-page';

export const Route = createFileRoute('/_protected/channel-partner/apply')({
  component: ChannelPartnerApplyPage,
});
